// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__rsvf7","notes":"Notes_notes__2n1bs","note":"Notes_note__3yNSQ","markdown":"Notes_markdown__Gb8L0"};